import { useState, useEffect } from 'react'
import scrollToElement from 'scroll-to-element'
import { BrowserUtils } from '../utils/siteUtils'

export { default as useDataFetcher } from './useDataFetcher'

export const useStateValue = initValue => {
  const [value, setValue] = useState(initValue)
  const selectValue = newValue => setValue(newValue)
  return [value, selectValue]
}

export const useReRenderer = () => {
  const [random, setRandom] = useState(Math.random())
  const reRender = () => setRandom(Math.random())
  return [reRender, random]
}

export const useToggler = initValue => {
  const [value, setValue] = useState(initValue)
  const toggle = () => setValue(!value)
  return [value, toggle]
}

export const useLogger = name => {
  useEffect(() => {
    console.log('effect!', name)
    return () => console.log('unmount!', name)
  }, [name])
  return []
}

export const useTicker = (millis, max = -1) => {
  const [count, setCount] = useState(0)
  useEffect(() => {
    let mounted = true
    const func = async () => {
      await new Promise(_ => setTimeout(_, millis))
      if (mounted) setCount(count + 1)
    }
    if (count < max || max === -1) {
      func()
    }
    return () => (mounted = false)
  }, [millis, count, max])
  return [count]
}
export const useScroller = () => {
  const [hasScrolled, setHasScrolled] = useStateValue(false)
  const scroll = (targetElement, alignmentPosition = 'middle') => {
    !hasScrolled && scrollToElement(targetElement, { align: alignmentPosition })
    if (BrowserUtils.isIframe()) {
      try {
        const elementName = targetElement.substring(1)
        const element = typeof document !== 'undefined' && document.getElementById(elementName).getBoundingClientRect()
        const scrollToY = element && element.y
        const payload = { scrollToY, action: 'scrollTo' }
        BrowserUtils.postMessage(JSON.stringify(payload), '*')
      } catch {}
    }
  }

  return [setHasScrolled, scroll]
}
